import React from 'react';
import PropTypes from 'prop-types';
import GraphicsItem from './GraphicsItem';
import GraphicsItemRTL from './GraphicsItemRTL';

const GraphicsList = ({ items, dir }) => {
  const ItemComponent = dir === 'rtl' ? GraphicsItemRTL : GraphicsItem;
  
  return (
    <div style={{
      width: '100%',
      maxWidth: 360,
      display: 'flex',
      flexDirection: 'column',
      gap: 60
    }}>
      {items.map((it, idx) => (
        <ItemComponent 
          key={idx}
          icon={it.icon}
          title={it.title}
          description={it.description}
          alt={it.alt || `graphic-${idx}`}
        />
      ))}
    </div>
  );
};

GraphicsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
  dir: PropTypes.string
};

export default GraphicsList;
